"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.codecSupportsVideoBitrate = exports.codecSupportsCrf = exports.codecSupportsMedia = void 0;
const crf_1 = require("./crf");
const support = {
    'h264-mkv': {
        audio: true,
        video: true,
    },
    aac: {
        audio: true,
        video: false,
    },
    gif: {
        video: true,
        audio: false,
    },
    h264: {
        video: true,
        audio: true,
    },
    'h264-ts': {
        video: true,
        audio: true,
    },
    h265: {
        video: true,
        audio: true,
    },
    mp3: {
        audio: true,
        video: false,
    },
    prores: {
        audio: true,
        video: true,
    },
    vp8: {
        audio: true,
        video: true,
    },
    vp9: {
        audio: true,
        video: true,
    },
    wav: {
        audio: true,
        video: false,
    },
};
const codecSupportsMedia = (codec) => {
    return support[codec];
};
exports.codecSupportsMedia = codecSupportsMedia;
const codecSupportsVideoBitrateMap = {
    'h264-mkv': true,
    'h264-ts': true,
    aac: false,
    gif: false,
    h264: true,
    h265: true,
    mp3: false,
    prores: false,
    vp8: true,
    vp9: true,
    wav: false,
};
const codecSupportsCrf = (codec) => {
    const range = (0, crf_1.getValidCrfRanges)(codec);
    return range[0] !== range[1];
};
exports.codecSupportsCrf = codecSupportsCrf;
const codecSupportsVideoBitrate = (codec) => {
    return codecSupportsVideoBitrateMap[codec];
};
exports.codecSupportsVideoBitrate = codecSupportsVideoBitrate;
